import type { ReactNode } from 'react';
import { graphql, useFragment } from 'react-relay';

import { CHARGE_STATUS_ENUM } from '@woovi/shared';

import type { PaymentMethodBoletoSelected_charge$key } from './__generated__/PaymentMethodBoletoSelected_charge.graphql.ts';
import type { PaymentMethodBoletoSelected_query$key } from './__generated__/PaymentMethodBoletoSelected_query.graphql.ts';
import PaymentActiveBoleto from '../active/boleto/PaymentActiveBoleto.tsx';
import PaymentCompleted from '../completed/PaymentCompleted.tsx';
import PaymentMethodSelectedCustomerRegister from '../paymentMethod/PaymentMethodSelectedCustomerRegister.tsx';

type PaymentMethodBoletoSelectedProps = {
  charge: PaymentMethodBoletoSelected_charge$key;
  query: PaymentMethodBoletoSelected_query$key;
};

const PaymentMethodBoletoSelected = (
  props: PaymentMethodBoletoSelectedProps,
): ReactNode => {
  const query = useFragment<PaymentMethodBoletoSelected_query$key>(
    graphql`
      fragment PaymentMethodBoletoSelected_query on Query {
        ...PaymentCompleted_query
      }
    `,
    props.query,
  );

  const charge = useFragment<PaymentMethodBoletoSelected_charge$key>(
    graphql`
      fragment PaymentMethodBoletoSelected_charge on Charge {
        id
        status
        customer {
          id
        }
        ...PaymentActiveBoleto_charge
        ...PaymentCompleted_charge
        ...PaymentMethodSelectedCustomerRegister_charge
      }
    `,
    props.charge,
  );

  if (!charge?.customer?.id) {
    return <PaymentMethodSelectedCustomerRegister charge={charge} />;
  }

  if (charge.status === CHARGE_STATUS_ENUM.COMPLETED) {
    return <PaymentCompleted charge={charge} query={query} />;
  }

  return <PaymentActiveBoleto charge={charge} />;
};

export default PaymentMethodBoletoSelected;
